import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";

import { currencyFormatter } from "../../../../lib/presentation";
import type { ClientPurchasedItemRow } from "../../../../types";

export default function PurchaseBehaviorTopItemsTable({
    rows,
}: {
    rows: ClientPurchasedItemRow[];
}) {
    return (
        <Paper className="table-card" elevation={0}>
            <Box className="table-card__header">
                <Box>
                    <Typography variant="h5">Топ 10 артикула</Typography>
                    <Typography variant="body2" color="text.secondary">
                        Какво купува клиентът най-често и с каква стойност.
                    </Typography>
                </Box>
            </Box>
            <Box className="table-card__scroller">
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Артикул</TableCell>
                            <TableCell>Категория</TableCell>
                            <TableCell align="right">Количество</TableCell>
                            <TableCell align="right">Средна цена</TableCell>
                            <TableCell align="right">Стойност</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.length === 0 ? <EmptyRow /> : rows.map((row) => <ItemRow key={`${row.goodId}-${row.articleCode}`} row={row} />)}
                    </TableBody>
                </Table>
            </Box>
        </Paper>
    );
}

function EmptyRow() {
    return (
        <TableRow>
            <TableCell colSpan={5}>
                <Typography color="text.secondary">
                    Няма намерени артикули за последните 12 месеца.
                </Typography>
            </TableCell>
        </TableRow>
    );
}

function ItemRow({ row }: { row: ClientPurchasedItemRow }) {
    return (
        <TableRow hover>
            <TableCell>
                <Typography sx={{ fontWeight: 800 }}>{row.articleName}</Typography>
                <Typography variant="body2" color="text.secondary">
                    {row.articleCode || "Без код"}
                </Typography>
            </TableCell>
            <TableCell>{row.category || "—"}</TableCell>
            <TableCell align="right">{row.totalQty}</TableCell>
            <TableCell align="right">{currencyFormatter.format(row.avgPrice)}</TableCell>
            <TableCell align="right">{currencyFormatter.format(row.totalValue)}</TableCell>
        </TableRow>
    );
}
